import styled from 'styled-components';

export const OverflowYWrapper = styled.div`
  height: ${({ height }) => height};
  overflow-y: auto;
`;
